import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { ElementInViewport } from '../../common/components/elementInViewport';
import { IProject } from '../../types';
import { trackProjectListShow } from '../../utils/tracking/project';
import { CollapseButton } from '../CollapseButton';
import { ProjectList } from '../ProjectList';

import * as styles from './ProjectListBlock.css';

export interface IProjectListBlockProps {
  list: IProject[];
  isCollapsed: boolean;
  onCollapseLinkClick(isHidden: boolean): void;
}

export interface IProjectListBlockState {
  isCollapsed: boolean;
}

export class ProjectListBlock extends React.PureComponent<IProjectListBlockProps, IProjectListBlockState> {
  public state = {
    isCollapsed: this.props.isCollapsed,
  };

  public render() {
    const { list } = this.props;
    const { isCollapsed } = this.state;

    return (
      <ElementInViewport onChange={trackProjectListShow}>
        <div className={styles['container']}>
          <div className={styles['header']}>
            <strong className={styles['title']}>Проекты домов, доступные в этой локации</strong>
            <CollapseButton
              buttonStyles={styles['collapse_toggle']}
              isCollapsed={isCollapsed}
              onClick={this.onToggleCollapseLinkClick}
            />
          </div>
          <div {...mergeStyles(styles['content'], isCollapsed && styles['content--hidden'])}>
            <p className={styles['text']}>При покупке участка вы сможете реализовать на нем один из этих проектов.</p>
            <ProjectList list={list} />
          </div>
        </div>
      </ElementInViewport>
    );
  }

  private onToggleCollapseLinkClick = () => {
    const isCollapsed = !this.state.isCollapsed;

    this.props.onCollapseLinkClick(isCollapsed);

    this.setState({
      isCollapsed,
    });
  };
}
